import {useEffect, useRef} from 'react';

export function createSizeHandler(element, setMainContainerHeight, setMainContainerWidth, props){
  return function(){
      if (element.current){
        setMainContainerHeight(element.current.clientHeight);
        setMainContainerWidth(element.current.clientWidth);
        if (props.reportHeight){
          props.reportHeight(element.current.clientHeight);
        }
        if (props.reportWidth){
          props.reportWidth(element.current.clientWidth);
        }
      }
    }

}

export function createSizeEffect(element, setMainContainerHeight, setMainContainerWidth, props){
  if (element.current){
    setMainContainerHeight(element.current.clientHeight);
    setMainContainerWidth(element.current.clientWidth);
    if (props.reportHeight){
      props.reportHeight(element.current.clientHeight);
    }
    if (props.reportWidth){
      props.reportWidth(element.current.clientWidth);
    }
  }  
}


// Hook
export function useEventListener(eventName, handler, element = window){
  // Create a ref that stores handler
  const savedHandler = useRef();
  
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(
    () => {
      const isSupported = element && element.addEventListener;
      if (!isSupported) return;
      
      // Create event listener that calls handler function stored in ref
      const eventListener = event => savedHandler.current(event);
      
      // Add event listener
      element.addEventListener(eventName, eventListener);
      
      // Remove event listener on cleanup
      return () => {
        element.removeEventListener(eventName, eventListener);
      };
    },
    [eventName, element] // Re-run if eventName or element changes
  );
};

export function updateSubsetDimensions(setArrayOfHeights){
  return function(newHeight){
    setArrayOfHeights(newHeight);
  }
}
